import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Card, Col, Row } from 'react-bootstrap';
import { getColor } from 'helpers/utils';
import SimpleBarReact from 'simplebar-react';
import FalconCardHeader from 'components/common/FalconCardHeader';

const TopFaturamento = ({
  meses,
  values,
  valoresConvertidos,
  title,
  height
}) => {
  // Filtrar dados para remover valores zero
  // Filtrar dados para remover valores nulos e zero
  const validData = values
    .map((value, index) => ({ value, month: meses[index] }))
    .filter(data => data.value !== null && data.value !== 0); // Remover nulos e zeros

  const filteredValues = validData.map(data => data.value);
  const filteredMeses = validData.map(data => data.month);

  const getOption = () => {
    if (filteredValues.length === 0) {
      return {}; // Retorna um objeto vazio se não houver dados válidos
    }

    const maxValue = Math.max(...filteredValues);
    const interval = Math.ceil(maxValue / 50000);
    return {
      tooltip: {
        trigger: 'item',
        backgroundColor: getColor('gray-100'),
        borderColor: getColor('gray-300'),
        textStyle: {
          fontSize: 10,
          color: getColor('gray-1100')
        },
        formatter: params => {
          const valorConvertido =
            valoresConvertidos[filteredMeses.indexOf(params.name)] || 0;
          return `<strong>${
            params.name
          }:</strong> ${valorConvertido.toLocaleString()}`;
        }
      },
      xAxis: {
        type: 'category',
        data: filteredMeses, // Usar meses filtrados
        axisLabel: {
          formatter: value => {
            return value.length > 60 ? value.substring(0, 60) + '...' : value;
          },
          align: 'center',
          textStyle: {
            fontSize: 10
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#ccc'
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: value => {
            return value.toLocaleString();
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#ccc'
          }
        }
      },
      series: [
        {
          name: 'Valor',
          type: 'bar',
          data: filteredValues, // Usar valores filtrados
          barWidth: '50%',
          itemStyle: {
            color: getColor('primary')
          },
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false
            }
          }
        }
      ],
      grid: {
        left: '10%',
        right: '5%',
        top: '10%',
        bottom: '10%'
      }
    };
  };

  return (
    <Card className={height}>
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact
        style={{ height: '26rem', overflowY: 'hidden' }}
        autoHide={false}
      >
        <Card.Body className="ps-2">
          {Array.isArray(filteredValues) && filteredValues.length > 0 ? (
            <div
              style={{ transform: 'scale(0.9)', transformOrigin: 'top center' }}
            >
              <ReactECharts option={getOption()} />
            </div>
          ) : (
            <div className="text-center p-3">Sem registros</div>
          )}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

export default TopFaturamento;
